import { Checkbox } from "@mantine/core";
import CheckboxSurvey from "../../../components/form/Checkbox";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
};

const OPTIONS_VALUES = [
  "cos_001",
  "cos_002",
  "cos_003",
  "cos_004",
  "cos_005",
];

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <CheckboxSurvey
      label={t("consequences.label")}
      {...form.getInputProps("COS_001_005")}
    >
      {(
        t("consequences.questions", {
          returnObjects: true,
        }) as string[]
      ).map((option, index) => (
        <Checkbox
          key={OPTIONS_VALUES[index]}
          label={option}
          value={OPTIONS_VALUES[index]}
        />
      ))}
    </CheckboxSurvey>
  );
};

export default Component;
